<template>
    <div>
        
        <div class="page justify-content-center">
            <div class="container" style="padding:20px;margin-bottom:40px;">
            <div class="row align-items-center">
                <div class="col-md-4 offset-md-2">
                    <img src="/static/geofolio-logo.svg" style="height:45px;margin-bottom:15px;margin-top:20px;margin-right:10px;float:none;">
            
                </div>
                <div class="col-md-4 text-right">
                    <a href="/" style="font-size:1em;"><i class="bi bi-arrow-up-left"></i> Back to main homepage</a>
                </div>
            </div>
                <div class="row justify-content-center">
                    <div class="col-md-8">

                        <div style="padding:20px;margin-top:20px;background-color:#fff;border:1px solid #ccc;">

                            <div v-if="(profile) && (profile.is_public == false)" class="text-center">
<p>You are already logged in as user <strong>{{ profile.username }}</strong>.</p>
<p style="margin-bottom:0;">You should probably just continue to the <router-link :to="{ name: 'home' }">My Geofolio</router-link> homepage.</p>
                            </div>
                            <div v-else>
                            <h2 style="margin:0px 0px 20px 0px;">Sign up for a Geofolio account</h2>
                                
                                <div v-if="result">
                                    {{result}}
                                </div>
                                <div v-else>

                                <form>
                                  <div class="form-group">
                                    <input v-model="other" type="text" name="other" id="other" ref="other" style="position:absolute;top:-1000px">
                                    <label for="email">Email Address (Required)</label>
                                    <input v-model="email" ref="email" type="email" class="form-control" id="email" placeholder="">

                                    
                                    
                                  </div>
                                  <div class="form-group">
                                    <label for="name">Name (Optional but appreciated)</label>
                                    <input  v-model="name" type="name" ref="name" class="form-control" id="name" placeholder="">
                                  </div>
                                  
                                  <div class="form-group">
                                    <label for="exampleInputPassword1">We have a very plain newsletter that we send out once every few months with updates about the site. Can we add you to the list?</label>
                                    <div class="custom-control custom-radio custom-control-inline">
                                      <input v-model="newsletter" type="radio" id="newsletter-yes" name="newsletter" value="newsletter-yes" class="custom-control-input">
                                      <label class="custom-control-label" for="newsletter-yes" >Yes</label>
                                    </div>
                                    <div class="custom-control custom-radio custom-control-inline">
                                      <input v-model="newsletter" type="radio" id="newsletter-no" name="newsletter" value="newsletter-no" class="custom-control-input">
                                      <label class="custom-control-label" for="newsletter-no">No</label>
                                    </div>
                                  </div>
                                  <hr/>
                                  <div class="form-group">
                                  <h2 style="margin:10px 0px 10px 0px;">Terms of service</h2>
                                  <label>
                                    By creating an account you must agree to our <a href="/terms-of-service/" target="_blank">terms of service</a>. The terms state things like that we can disable your account if you abuse the service, and that you don't hold us accountable if something breaks or is inaccurate.</label>

                                    <div class="custom-control custom-radio custom-control-inline">
                                      <input v-model="terms" type="radio" id="terms-yes" name="terms" value="terms-yes" class="custom-control-input">
                                      <label class="custom-control-label" for="terms-yes" >Yes</label>
                                    </div>
                                    <div class="custom-control custom-radio custom-control-inline">
                                      <input v-model="terms" type="radio" id="terms-no" name="terms" value="terms-no" class="custom-control-input disabled">
                                      <label class="custom-control-label" for="terms-no">No</label>
                                    </div>
                                  </div>
                                  <hr/>

                                <p>
                                    Already have an account and ended up here accidentally? You can <router-link :to="{ name: 'login' }">log in</router-link> instead.
                                </p>
                                <p v-if="error" style="margin-bottom:10px;" class="is-invalid">{{ error }}</p>
                                <button type="submit" @click.prevent="register" ref="register" class="btn btn-lg btn-primary" :disabled="disabled"><strong>Register</strong></button>

                                </form>
                            </div>
                        </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
  import MainHeader from '@/components/generic/MainHeader.vue'
  import Footer from '@/components/generic/Footer.vue'

  
  export default {
      data() {
        return {
          error: null,
          result: null,
          email: '',
          name: '',
          terms: "terms-yes",
          newsletter: "newsletter-yes",
          other: '',
          disabled: false
        }
      },
      mounted() {
        this.$refs["email"].focus()
      },
      computed: {
        profile() {
            if(this.$store.state.profile) {
                return this.$store.state.profile
              } else {
                return this.$store.state.profile_pub;
              }
        },
        emailOk() {
            return String(this.email).toLowerCase().match(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)
        },
        termsOk() {
            return (this.terms == 'terms-yes')
        },
        formOk() {
            return (this.emailOk && this.termsOk)
        }
      },
    methods: {
      register() {
        this.$refs["register"].blur();
        this.disabled = true;
        if(!this.termsOk) {
            this.error = "You must agree to the terms of service to create an account."
            this.disabled = false;
            return
        }
        if(!this.emailOk) {
            this.error = "Please enter a valid e-mail address to create an account."
            this.disabled = false;
            return
        }
        if(this.other) {
            this.error = "Something went wrong with the form. Contact info@geofolio.org for more information."
            this.disabled = false;
            return
        }
        const params = {
           'email': this.email,
           'name': this.name,
           'newsletter': this.newsletter,
           'terms': this.terms,
           'other': this.other
        }
        const headers = {
            'X-CSRFTOKEN': this.csrfcookie()
        }
        this.$axios
           .post(process.env.VUE_APP_API+"/api/register", params, { headers: headers })
           .then(response => {
                this.result = response.data.message
                this.disabled = false;
           })
           .catch(error => {
                this.result = "An unexpected error occurred while processing your request. Contact info@geofolio.org for more information."
                this.disabled = false;
           })
      }
    },
    name: 'signup',
    components: {
      MainHeader, Footer
    }
  }
</script>

<style scoped>

div.page {
    font-size:1.2em;
    color:#666;
}
h1 {
    font-size:1.3em;
    font-weight:600;
    margin-top:15px;
}

h2 {
    font-size:1.2em;
    font-weight:600;
    margin-top:15px;
}

h3 {
    font-size:1.05em;
    font-weight:600;
    margin-top:15px;
}
p {
    line-height:1.4em;
}

.is-invalid {
    color: #dc3545;
}
label.is-invalid {
    font-weight:bold;
}
</style>